import React, {useState} from "react";
import "./SideMenu.css";
import {Logo} from "../../../assets/images";
import {Link, useLocation, useNavigate} from "react-router-dom";

const menuItems = [
  {id: "home", label: "Home"},
  {id: "service", label: "Services"},
  {id: "projects", label: "Projects"},
  {id: "testimonial", label: "Testimonial"},
  {id: "about", label: "About"},
];

const SideMenu = ({isOpen, closeMenu, activeSection}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const SCROLL_OFFSET = 100; // Adjust this value based on your sticky header height

  const handleScrollLink = (id) => {
    closeMenu();
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) {
        const topOffset =
          el.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
        window.scrollTo({top: topOffset, behavior: "smooth"});
      }
    } else {
      navigate("/", {state: {scrollTarget: id}});
    }
  };

  return (
    <>
      <div className="side-menu-area">
        <div className={`side-menu ${isOpen ? "opened" : ""}`}>
          {/* Close Button */}
          <div className="side-menu__close-btn">
            <button className="close-btn" onClick={closeMenu}>
              <i className="fal fa-times"></i>
            </button>
          </div>

          {/* Logo */}
          <div className="side-menu__logo">
            <Link to="/" onClick={closeMenu}>
              <img src={Logo} alt="logo" />
            </Link>
          </div>

          {/* Title */}
          <div className="side-menu__title">
            <p>
              Trusted by global brands and growing startups, I craft seamless,
              high-performance digital experiences that elevate business
              outcomes.
            </p>
          </div>

          {/* Navigation Menu */}
          <div className="main-side-menu-mobile d-xl-none">
            <nav className="main-side-menu-content">
              <ul className="side-onepage-menu">
                {menuItems.map(({id, label}) => (
                  <li key={id} className={activeSection === id ? "active" : ""}>
                    <a onClick={() => handleScrollLink(id)}>{label}</a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="side-menu__contact-info">
            <div className="side-menu__contact-title">
              <h5>Contact us</h5>
            </div>
            <ul>
              <li>
                <i className="fa-solid fa-location-dot"></i>
                <a
                  href="https://maps.app.goo.gl/cDMgfV8LparnZJho6"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Surat, Gujarat, India
                </a>
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <a
                  href="mailto:contact@deepkapadia.work"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  contact@deepkapadia.work
                </a>
              </li>
              <li>
                <i className="fa-solid fa-phone-flip"></i>
                <a
                  href="tel:+919662520605"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  (+91) 96625 20605
                </a>
              </li>
            </ul>
          </div>

          {/* Social Icons */}
          <div className="side-menu__social">
            <div className="social-icon">
              <a
                href="https://www.facebook.com/deep.kapadia.927"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/deep_kapadia/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay */}
      <div
        className={`body-overlay ${isOpen ? "apply" : ""}`}
        onClick={closeMenu}
      ></div>
    </>
  );
};

export default SideMenu;
